import { isTypeLogoSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulLogo from './ContentfulLogo';

const ContentfulLogoSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeLogoSection(entry)) {
    return null;
  }

  return (
    <div className='sm:max-w-[1440px] sm:mx-auto flex flex-col items-center py-8 sm:py-16 border-b border-gray-100'>
      <div className='text-xl sm:text-2xl text-gray-600 font-light text-center'>
        {entry.fields.subHeader}
      </div>
      <div className='flex flex-wrap place-content-around sm:justify-center sm:content-evenly w-full gap-4'>
        {entry.fields.logos?.map((logo) => <ContentfulLogo key={logo?.sys.id} entry={logo} />)}
      </div>
    </div>
  );
};

export default ContentfulLogoSection;
